<script>
import { mapState, mapActions } from 'vuex';
/* components */
import LeaderboardTable from '@/components/LeaderboardTable';
import Pagination from '@/components/Pagination';
import Dropdown from '@/components/Dropdown';
import DashboardTabs from '@/components/DashboardTabs';
import Balance from '@/components/Balance';
import TabsSlider from '@/components/TabsSlider';
/* tools */
import { applyLanguage } from '@/scripts/language';
import { getDropdownValue } from '@/scripts/utils/collection';
import { gameSetup } from '@/scripts/computed';
import { getLeaderboardStats } from '@/scripts/api/stats';
import { timeFilterSet } from '@/scripts/constants/map';
import { mobile, currentGameTypes, gameTypeSetup } from '@/scripts/computed';
import { getGameTypes as getTypes } from '@/scripts/api/games';
import { isEqual } from 'lodash';
import Spinner from '@/components/Spinner';

export default {
  name: 'Leadboard',
  components: {
    Balance,
    DashboardTabs,
    TabsSlider,
    Dropdown,
    LeaderboardTable,
    Pagination,
    Spinner,
  },
  props: {},
  data() {
    return {
      /* > */
      leaderboardPage: 1,
      leadBoardBodyData: null,
      sortField: '_rank',
      sortDirection: 'asc',
      /* < */
      lastParams: null,
      loading: false,
    };
  },
  watch: {
    sortField(sortField) {
      this.updateTable({ sortField });
    },
    sortDirection(sortDirection) {
      this.updateTable({ sortDirection });
    },
    leaderboardPage(leaderboardPage) {
      this.updateTable({ leaderboardPage });
    },
    activeTimeFilter(activeTimeFilter) {
      this.updateTable({
        lifetimeDataSorting: activeTimeFilter === 'lifetimeData',
      });
    },
    activeGameType(activeGameType) {
      this.sortDirection = 'asc';
      this.sortField = '_rank';

      const { currentGameTypes } = this;

      if (!currentGameTypes || !currentGameTypes.length) {
        return null;
      }

      const activeGameTypeSetup = currentGameTypes.find(
        ({ id }) => id === activeGameType
      );

      if (activeGameTypeSetup) {
        const { lifetimeDataSupport } = activeGameTypeSetup;

        if (!lifetimeDataSupport) this.setTimeFilter(timeFilterSet[0]);
      }

      this.updateTable({ activeGameType });
    },
    activeGame(activeGame) {
      if (this.currentGameTypes) {
        this.setNewGameDefaultType(this.currentGameTypes);
      } else {
        this.getGameTypes(activeGame).then(this.setNewGameDefaultType);
      }
    },
  },
  computed: {
    ...mapState([
      'user',
      'games',
      'allGamesTypes',
      'activeGame',
      'activeGameType',
      'activeTimeFilter',
    ]),
    leadboardHead() {
      const { gameTypeSetup } = this;

      if (!gameTypeSetup) return null;

      const { leaderboardFields } = gameTypeSetup;

      if (!leaderboardFields) return null;

      const result = leaderboardFields;

      return result;
    },
    dropdownGameTypes() {
      const { currentGameTypes } = this;

      if (!currentGameTypes || !currentGameTypes.length) return null;

      const result = currentGameTypes.map(({ name, id }) => ({
        title: name,
        value: id,
      }));

      return result;
    },
    dashboardMode() {
      const { $slots: slots } = this;
      const result = !!(slots && slots.default);

      return result;
    },
    lifetimeDataSupport() {
      const { gameTypeSetup } = this;

      if (!gameTypeSetup) return null;

      const result = gameTypeSetup.lifetimeDataSupport;

      return result;
    },
    leadboardBody() {
      const { leadBoardBodyData, activeTimeFilter } = this;

      if (!leadBoardBodyData || !activeTimeFilter) return null;

      const { items, me } = leadBoardBodyData;

      const everybody = items.map(item => {
        const data = item[activeTimeFilter];
        const content = { ...data, me: item.me };

        return content;
      });

      const everybodyMinusMe = everybody.filter(({ me }) => !me);

      const plusMe = me
        ? [{ ...me[activeTimeFilter], me: true }, ...everybodyMinusMe]
        : everybody;
      const result = plusMe.length ? plusMe : null;

      return result;
    },
    pages() {
      const { leadBoardBodyData } = this;

      if (!leadBoardBodyData) return 1;

      const { 1: firstPage } = leadBoardBodyData;

      if (!firstPage) return 1;

      const { total, perPage } = firstPage;
      const result = Math.ceil(total / perPage);

      return result;
    },
    timeFilterSet() {
      const { lifetimeDataSupport } = this;
      const result = lifetimeDataSupport ? timeFilterSet : [timeFilterSet[0]];

      return result;
    },
    currentGameTypes,
    gameTypeSetup,
    gameSetup,
    mobile,
  },
  created() {
    const { activeGame, currentGameTypes, activeGameType } = this;

    if (currentGameTypes) {
      if (activeGameType) {
        this.updateTable({ activeGameType });
      } else {
        this.setNewGameDefaultType(this.currentGameTypes);
      }
    } else {
      this.getGameTypes(activeGame).then(this.setNewGameDefaultType);
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      setGameTypes: 'setGameTypes',
      setActiveGame: 'setActiveGame',
      setActiveGameType: 'setActiveGameType',
      setActiveTimeFilter: 'setActiveTimeFilter',
      setActiveGamePlatform: 'setActiveGamePlatform',
    }),
    setNewGameDefaultType(types) {
      if (!types || !types.length) return null;

      const [firstTypeSetup] = types;

      this.setActiveGameType(firstTypeSetup.id);
    },
    setTimeFilter(type) {
      const activeTimeFilter = type.value;

      this.setActiveTimeFilter(activeTimeFilter);
    },
    setDropdownGameType(type) {
      const activeGameType = type ? type.value : null;

      this.setActiveGameType(activeGameType);
    },
    getGameTypes(id) {
      this.loading = true;

      return getTypes(id)
        .then(games => {
          const types = games.items;

          this.setGameTypes({ id, types });
          this.loading = false;

          return types;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /*  */
    updateTable(forcedParams = {}) {
      const sortField = forcedParams.sortField || this.sortField;
      const sortDirection = forcedParams.sortDirection || this.sortDirection;
      const gameTypeID = forcedParams.activeGameType || this.activeGameType;
      const page = forcedParams.leaderboardPage || this.leaderboardPage;
      const lifetimeDataSorting =
        forcedParams.lifetimeDataSorting || this.lifetimeDataSorting;

      const params = {
        gameTypeID,
        page,
        lifetimeDataSorting,
        sortField,
        sortDirection,
      };

      const repetition = isEqual(params, this.lastParams);
      const prevent = !gameTypeID || repetition;

      if (prevent) {
        return null;
      }

      this.lastParams = params;
      this.loading = true;

      return getLeaderboardStats(params)
        .then(pageData => {
          this.leadBoardBodyData = pageData;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setActiveGameProxy(id) {
      this.setActiveGameType(null);
      this.setActiveGame(id);

      /*  */
      // this.setActiveGamePlatform(null);
    },
    sortTable(field) {
      const opposite = this.sortDirection === 'asc' ? 'desc' : 'asc';

      this.sortDirection = this.sortField === field ? opposite : 'asc';
      this.sortField = field;
    },
    applyLanguage,
    getDropdownValue,
  },
};
</script>

<template>
  <div class="leadboard">
    <div class="leadboard__content">
      <!-- row tabs -->
      <div
        class="leadboard__row leadboard__row--tabs-dashboard hide-mobile"
        v-if="dashboardMode"
      >
        <!-- > -->
        <portal-target name="controls-game" />
        <!-- < -->
      </div>
      <div class="leadboard__row leadboard__row--head">
        <div class="leadboard__title">
          {{ dashboardMode ? 'Dashboard' : 'Leaderboard' }}
        </div>
        <!-- > -->
        <portal-target name="controls" class="portals-filter" />
        <!-- < -->
        <div class="leadboard__balance">
          <!-- balance -->
          <Balance />
        </div>
      </div>
      <!--  -->
      <div
        class="leadboard__row leadboard__row--filter"
        :class="{ 'visible-mobile': dashboardMode }"
      >
        <!-- tabs -->
        <portal to="controls-game" :disabled="!dashboardMode || mobile">
          <div class="leadboard__tabs">
            <TabsSlider>
              <DashboardTabs
                :gameSetup="gameSetup"
                :disabled="loading"
                @change="setActiveGameProxy"
              />
            </TabsSlider>
          </div>
        </portal>

        <portal to="controls" :disabled="!dashboardMode || mobile">
          <div class="leadboard__filter">
            <div
              class="leadboard__filter-dropdown"
              :class="{ 'leadboard__filter-refresh': $slots.refresh }"
            >
              <!-- game platform -->
              <div
                class="leadboard__dropdown leadboard__dropdown--lg z-3"
                v-if="$slots.platform"
              >
                <slot name="platform" />
              </div>
              <!-- game type -->
              <div class="leadboard__dropdown z-2">
                <Dropdown
                  :items="dropdownGameTypes"
                  :force-value="
                    getDropdownValue(activeGameType, dropdownGameTypes)
                  "
                  @change="setDropdownGameType"
                />
              </div>
              <!-- time filter -->
              <div class="leadboard__dropdown z-1">
                <Dropdown
                  :items="timeFilterSet"
                  :force-value="
                    getDropdownValue(activeTimeFilter, timeFilterSet)
                  "
                  @change="setTimeFilter"
                />
              </div>
              <!-- refresh -->
              <div class="leadboard__refresh" v-if="$slots.refresh">
                <slot name="refresh" />
              </div>
            </div>
          </div>
        </portal>
      </div>
      <!--  -->
      <div class="leadboard__row leadboard__row--slider" v-if="dashboardMode">
        <slot name="banners" />
      </div>

      <!-- >dashboard body -->
      <slot />
      <!-- <dashboard body -->

      <div
        v-if="dashboardMode"
        class="leadboard__title"
        :class="{ 'hide-mobile': dashboardMode }"
      >
        Leaderboard
      </div>

      <!--  -->
      <div class="spinner">
        <Spinner :show="loading" />
      </div>

      <div
        class="leadboard__row leadboard__row--table"
        :class="{ 'hide-mobile': dashboardMode }"
      >
        <LeaderboardTable
          v-if="!loading"
          :loading="loading"
          :head="leadboardHead"
          :body="leadboardBody"
          :sort-field="sortField"
          :sort-direction="sortDirection"
          :gameSetup="gameSetup"
          @sort="sortTable"
        />
      </div>

      <div
        class="leadboard__row leadboard__row--pagination"
        :class="{ 'hide-mobile': dashboardMode }"
      >
        <Pagination
          :page="leaderboardPage"
          :pages="pages"
          @set-page="n => (leaderboardPage = n)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.leadboard {
  &__content {
    padding: 30px 30px 100px 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
    position: relative;
  }

  &__row {
    width: 100%;

    &--filter {
      margin-bottom: 20px;

      &.visible-mobile {
        display: none;
      }
    }

    &--pagination {
      width: 100%;
      margin-top: 50px;
    }

    &--tabs-dashboard {
      margin-bottom: 65px;
    }

    &--head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 30px;
    }

    &--slider {
      width: 100%;
      max-width: 2580px;
    }

    &--table {
      width: 100%;
      min-height: 300px;
    }
  }

  &__title {
    font-family: Poppins-Light;
    font-size: 36px;
    line-height: 51px;
    color: #ffffff;
    text-align: left;
  }

  &__filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 50px;
  }

  &__filter-wrapper {
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-content: flex-start;
  }

  &__tabs {
    display: flex;
    flex-grow: 1;
    height: 60px;
  }

  &__filter-dropdown {
    display: flex;
    align-items: center;
    padding-left: 30px;
    flex-wrap: wrap;
    margin-top: -10px;
  }

  &__refresh {
    border-left: 1px solid rgba(0, 184, 249, 0.4);
    margin-right: 30px;
    padding-left: 30px;
    margin-left: 30px;
    display: flex;
    align-items: center;
  }

  &__dropdown {
    width: 183px;
    margin-top: 10px;
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }

    &.z-1 {
      position: relative;
      z-index: 1;
    }
    &.z-2 {
      position: relative;
      z-index: 2;
    }
    &.z-3 {
      position: relative;
      z-index: 3;
    }
  }
}

.portals-filter {
  display: flex;
  flex-grow: 1;

  .leadboard__filter {
    margin-top: 0;
  }
  .leadboard__refresh {
    margin-top: 10px;
  }
}

@media (max-width: $mobile) {
  .hide-mobile {
    display: none;
  }

  .leadboard {
    &__content {
      padding: 20px 0 80px;
    }

    &__title {
      font-size: 21px;
      line-height: 29px;
    }

    &__refresh {
      margin-left: 15px;
      margin-top: 20px;
      margin-right: 0;
      padding: 0;
      border: 0;
    }

    &__row {
      &--head {
        align-items: flex-start;
        justify-content: space-between;
        padding: 0 15px;
        margin-bottom: 20px;
      }

      &--filter {
        flex-direction: column;
        margin-bottom: 25px;

        &.visible-mobile {
          display: block;
        }
      }

      &--table {
        padding: 0 15px;
        min-height: auto;
      }

      &--pagination {
        margin-top: 40px;
      }

      &--slider {
        margin: 5px auto 0;
        width: 100%;
        max-width: 960px;
      }
    }

    &__tabs {
      width: 100%;
      height: 77px;
    }

    &__filter {
      margin-left: 0;
      margin-top: 10px;
      padding: 0;
      border: 0;
      width: 100%;
      padding: 0 15px;
    }

    &__filter-dropdown {
      justify-content: center;
      padding: 0;
      margin-left: -10px;
      margin-top: -20px;
      flex-grow: 1;
    }

    &__dropdown {
      width: calc(50% - 10px);
      max-width: 140px;
      margin-right: 0;
      margin-left: 10px;
      margin-top: 20px;
      max-width: none;

      &--lg {
        width: 100%;
      }
    }

    &__filter-dropdown {
      &.leadboard__filter-refresh {
        position: relative;

        .leadboard__dropdown {
          width: calc(50% - 10px);
          flex-grow: 1;

          &:first-child {
            width: 100%;
            margin-right: 60px;
          }
        }

        .leadboard__refresh {
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
  }
}
</style>
